// @flow
import React, { memo } from "react";
import t from "common/i18n";
import RadioGroup from "root/components/RadioGroup";

type Props = {
    value: ?number,
    className: string,
    onChange: Function,
};

const DURATION_OPTIONS = ["short", "long"]
	.map((value) => ({
		value,
		label: t(`shutterstock.filters.duration.${value}`),
		tip: t(`shutterstock.filters.duration.${value}_tip`),
	}));

const VideoDuration = (props: Props) => <section className={`duration ${props.className}`}>
	<label>{t("shutterstock.filters.duration.label")}</label>
	<RadioGroup
		options={DURATION_OPTIONS}
		showAsBoxes
		enableDeselect
		onChange={(newValue) => props.onChange({ duration: newValue })}
		className="flex-shrink-0"
		value={props.value} />
</section>;

export default memo<Props>(VideoDuration);
